import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueParticles from "vue-particles";
import store from "./store";
import VueScrollTo from "vue-scrollto";
import Donut from "vue-css-donut-chart";
import "vue-css-donut-chart/dist/vcdonut.css";
import VModal from "vue-js-modal";
import "./style.scss";
import { Laue } from "laue";
import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);

Vue.component("apexchart", VueApexCharts);

Vue.use(Laue);
Vue.use(Donut);

Vue.use(VueScrollTo);

Vue.use(VueParticles);
Vue.use(VModal);

Vue.config.productionTip = false;

store.commit("initialiseStore");

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
